<template>
  <b-container
    ref="navmain"
    fluid
    class="app-nav shadow_1 h-100 px-0 text-font-grey bg-white"
  >
    <transition-group name="slideside" mode="out-in">
      <b-row align-v="center" class="px-0" key="logo-row">
        <b-col
          v-if="$root.isCollapsed"
          class="text-right"
          cols="3"
          lg="2"
          key="padspace"
        >
        </b-col>
        <b-col class="px-1 py-2 align-items-center" cols="6" md="12">
          <router-link :to="{ name: 'CompanyHome' }" class="">
            <img
              v-if="menuIsCompact && !$root.isCollapsed"
              :src="require(`@/assets/${$root.scope}/dot-logo.svg`)"
              :alt="$t('NavigationOperatore.logo_alt')"
              class="app-nav__logo app-nav__logo--compact px-lg-2 app_logo_compact"
              key="icon_logo"
            />
            <img
              v-else
              :src="require(`@/assets/${$root.scope}/logo.svg`)"
              :alt="$t('NavigationOperatore.logo_alt')"
              class="app-nav__logo app_logo_full"
              key="full_logo"
            />
          </router-link>
          <p v-if="isFever && !(menuIsCompact && !$root.isCollapsed)" class="mt-3">installazione .FARMA</p>
        </b-col>
        <b-col
          key="mobile_ham"
          v-if="$root.isCollapsed"
          class="text-right"
          cols="3"
          lg="2"
          @click="menuVisible = !menuVisible"
          @keydown.enter.prevent="menuVisible = !menuVisible"
          @keydown.space.prevent="menuVisible = !menuVisible"
          role="button"
          tabindex="0"
          :aria-label="$t('NavigationOperatore.toggle_menu')"
          :aria-expanded="menuVisible.toString()"
        >
          <b-icon font-scale="1.3" icon="filter-left" aria-hidden="true"></b-icon>
        </b-col>
      </b-row>
      <b-row cols="1" class="px-0" key="menu-row" v-if="menuVisible">
        <b-col
          class="px-2 px-md-4 px-lg-4 pb-xl-2 pb-1 pt-0 text-left app-nav__toggle"
          v-if="!$root.isCollapsed"
          key="desk_ham"
        >
          <p class="pb_15 nav__item bg-white">
            <span
              class="d-flex align-items-center pl-1 py-1 general_border_3 point pt-3"
              @click="handleMenuSize"
              @keydown.enter.prevent="handleMenuSize"
              @keydown.space.prevent="handleMenuSize"
              role="button"
              tabindex="0"
              :aria-label="$t('NavigationOperatore.toggle_menu')"
            >
              <b-icon font-scale="1.7" icon="filter-left" aria-hidden="true"></b-icon>
              <span class="mb-0 ml-2"></span>
              <span v-if="!menuIsCompact" class="text-font-light-grey"
                >MENU</span
              >
            </span>
          </p>
        </b-col>
        <b-col class="px-2 px-md-4 px-lg-4 pb-xl-2 pb-1 pt-0 text-left">
          <p class="text-font-light-grey">
            <span :class="menuIsCompact ? 'text-white' : ''"></span>
          </p>
          <p class="pb_15 nav__item bg-white">
            <router-link
              class="d-flex align-items-center pl-1 py-1 general_border_3"
              :class="
                this.$route.name === 'CompanyHome'
                  ? 'router-link-exact-active'
                  : ''
              "
              :to="{ name: 'CompanyHome' }"
            >
              <b-icon font-scale="1.3" icon="house-door"></b-icon>
              <span class="mb-0 ml-2">Dashboard</span>
            </router-link>
          </p>
          <p
            class="pb_15 nav__item bg-white"
            v-if="
              ((activeRefs.includes(1) && companyHasService(1)) ||
              (activeRefs.includes(2) && companyHasService(2))) &&
              user.permessi.includes('navigare calendario')
            "
          >
            <router-link
              class="d-flex align-items-center pl-1 py-1 general_border_3"
              :to="{ name: agendaSet.routeName }"
            >
              <b-icon font-scale="1.3" :icon="agendaSet.logo"></b-icon>
              <span class="mb-0 ml-2">{{ agendaSet.name }}</span>
            </router-link>
          </p>
          <p v-if="isFirstLevel && user.permessi.includes('navigare statistiche')" class="pb_15 nav__item bg-white">
            <router-link
              class="d-flex align-items-center pl-1 py-1 general_border_3"
              :to="{ name: analiticheSet.routeName }"
            >
              <b-icon font-scale="1.3" :icon="analiticheSet.logo"></b-icon>
              <span class="mb-0 ml-2">{{ analiticheSet.name }}</span>
            </router-link>
          </p>
          <p class="pb_15 nav__notifications">
            <NotificationCenter />
            <!-- <span class="mb-0 ml-2">Notifiche</span> -->
          </p>
          <p v-if="mostraMieConversazioni" class="pb_15 nav__item bg-white general_border_3">
            <span
              class="d-flex align-items-center pl-1 py-1 general_border_3 point position-relative"
              role="button"
              tabindex="0"
              :aria-label="$t('NavigationOperatore.mie_conversazioni')"
              @click="apriModaleChat"
              @keydown.enter.prevent="apriModaleChat"
              @keydown.space.prevent="apriModaleChat"
            >
              <b-icon font-scale="1.3" icon="chat-dots" aria-hidden="true"></b-icon>
              <span class="mb-0 ml-2">{{ $t('NavigationOperatore.mie_conversazioni') }}</span>
              <b-badge
                v-if="chatNonLetti > 0"
                variant="danger"
                pill
                class="ml-auto mr-2"
              >
                {{ chatNonLetti }}
              </b-badge>
            </span>
          </p>
        </b-col>
        <b-col class="px-2 px-md-4 px-lg-4 pb-xl-2 pb-1 pt-0 text-left">
          <!-- <p class="text-font-light-grey">
            <span :class="menuIsCompact ? 'text-white' : ''">SERVIZI</span>
          </p> -->
          <template v-for="(service, ind) in visibleActiveServices">
            <p
              v-if="
                activeRefs.includes(service.position_ref) &&
                companyHasService(service.position_ref) &&
                (!service.nav_permission || user.permessi.includes(service.nav_permission))
              "
              class="pb_15 nav__item"
              :class="service.submenu ? 'bg-mdm-light-grey' : 'bg-white'"
              :key="ind"
            >
              <template v-if="service.submenu">
                <span
                  :key="'sub-m-' + service.routeName"
                  class="d-flex align-items-center pl-1 py-1 general_border_3 point"
                  :class="
                    $route.name === service.routeName
                      ? 'router-link-exact-active'
                      : ''
                  "
                  @click="service.submenuVisible = !service.submenuVisible"
                  @keydown.enter.prevent="service.submenuVisible = !service.submenuVisible"
                  @keydown.space.prevent="service.submenuVisible = !service.submenuVisible"
                  role="button"
                  tabindex="0"
                  :aria-expanded="service.submenuVisible ? 'true' : 'false'"
                  :aria-controls="service.name + '-sub'"
                >
                  <b-icon font-scale="1.3" :icon="service.logo" aria-hidden="true"></b-icon>
                  <span class="mb-0 ml-2 text-capitalize">{{
                    service.name
                  }}</span>
                  <b-icon
                    font-scale="1"
                    :icon="
                      service.submenuVisible ? 'chevron-up' : 'chevron-down'
                    "
                    class="mr-1 ml-auto"
                    aria-hidden="true"
                  ></b-icon>
                </span>
                <b-collapse
                  class="mt-1"
                  :id="service.name + '-sub'"
                  v-model="service.submenuVisible"
                >
                  <template v-for="rt in service.subroutes">
                    <p
                      v-if="
                        !rt.position_ref ||
                        (rt.position_ref &&
                          activeRefs.includes(rt.position_ref) &&
                          companyHasService(rt.position_ref))
                      "
                      :key="'sub-' + rt.name"
                      class="mb-1"
                    >
                      <router-link
                        class="d-flex align-items-center pl-1 py-1 general_border_3 align-items-center"
                        :to="{
                          name: service.routeName,
                          params: { section: rt.path },
                        }"
                        exact-active-class="nav-active"
                      >
                        <b-iconstack aria-hidden="true" font-scale="1.3">
                          <b-icon
                            stacked
                            icon="circle"
                            variant="mdm-light-grey"
                            scale="0.55"
                          ></b-icon>
                          <b-icon
                            stacked
                            icon="circle"
                            variant="extra-light"
                          ></b-icon>
                        </b-iconstack>
                        <span class="mb-0 ml-2 text-capitalize">{{
                          rt.name
                        }}</span>
                      </router-link>
                    </p>
                  </template>
                </b-collapse>
              </template>
              <template v-else>
                <router-link
                  class="d-flex align-items-center pl-1 py-1 general_border_3"
                  :to="{
                    name: service.routeName,
                  }"
                >
                  <b-icon font-scale="1.3" :icon="service.logo"></b-icon>
                  <span class="mb-0 ml-2 text-capitalize">{{
                    service.name
                  }}</span>
                </router-link>
              </template>
            </p>
          </template>
          <p class="pb_15 nav__item bg-mdm-light-grey" v-if="!hideProjectMenu && user.permessi.includes('navigare progetti')">
            <template v-if="progetti.submenu">
              <span
                :key="'sub-m-' + progetti.routeName"
                class="d-flex align-items-center pl-1 py-1 general_border_3 point"
                :class="
                  $route.name === progetti.routeName
                    ? 'router-link-exact-active'
                    : ''
                "
                @click="progetti.submenuVisible = !progetti.submenuVisible"
                @keydown.enter.prevent="progetti.submenuVisible = !progetti.submenuVisible"
                @keydown.space.prevent="progetti.submenuVisible = !progetti.submenuVisible"
                role="button"
                tabindex="0"
                :aria-expanded="progetti.submenuVisible ? 'true' : 'false'"
                :aria-controls="progetti.name + '-sub'"
              >
                <b-icon font-scale="1.3" :icon="progetti.logo" aria-hidden="true"></b-icon>
                <span class="mb-0 ml-2 text-capitalize">{{
                  progetti.name.replace(/\s/g, "&nbsp;")
                }}</span>
                <b-icon
                  font-scale="1"
                  :icon="
                    progetti.submenuVisible ? 'chevron-up' : 'chevron-down'
                  "
                  class="mr-1 ml-auto"
                  aria-hidden="true"
                ></b-icon>
              </span>
              <b-collapse
                class="mt-1"
                :id="progetti.name + '-sub'"
                v-model="progetti.submenuVisible"
              >
                <p
                  v-for="rt in progetti.subroutes"
                  :key="'sub-' + rt.name"
                  class="mb-1"
                >
                  <router-link
                    class="d-flex align-items-center pl-1 py-1 general_border_3 align-items-center"
                    :to="{
                      name: progetti.routeName,
                      params: {
                        section: 'panoramica',
                        hashprogetto: rt.hashid,
                      },
                    }"
                    exact-active-class="nav-active"
                    :class="
                      $route.name === progetti.routeName &&
                      $route.params.hashprogetto === rt.hashid
                        ? 'nav-active'
                        : ''
                    "
                  >
                    <b-iconstack aria-hidden="true" font-scale="1.3">
                      <b-icon
                        stacked
                        icon="circle"
                        variant="mdm-light-grey"
                        scale="0.55"
                      ></b-icon>
                      <b-icon
                        stacked
                        icon="circle"
                        variant="extra-light"
                      ></b-icon>
                    </b-iconstack>
                    <span class="mb-0 ml-2 text-capitalize"
                      >{{ rt.name.replace(/\s/g, "&nbsp;") }}
                    </span>
                  </router-link>
                </p>
              </b-collapse>
            </template>
            <template v-else>
              <router-link
                class="d-flex align-items-center pl-1 py-1 general_border_3"
                :to="{
                  name: progetti.routeName,
                }"
              >
                <b-icon font-scale="1.3" :icon="progetti.logo"></b-icon>
                <span class="mb-0 ml-2 text-capitalize">{{
                  acquisti.name.replace(/\s/g, "&nbsp;")
                }}</span>
              </router-link>
            </template>
          </p>
        </b-col>
        <b-col class="px-2 px-md-4 px-lg-4 pb-xl-2 pb-1 pt-0 text-left">
          <p class="text-font-light-grey">
            <span :class="menuIsCompact ? 'text-white' : ''"></span>
          </p>
          <p class="pb_15 nav__item bg-white app-nav__user">
            <router-link
              class="d-flex align-items-center pl-1 py-1 general_border_3"
              :to="{ name: 'profilo operatore' }"
            >
              <b-avatar
                v-if="user && user.profile_pic"
                variant="white"
                :src="user.profile_pic"
                size="sm"
                rounded
              >
              </b-avatar>
              <b-icon
                v-else
                font-scale="1.3"
                :icon="
                  this.$route.name === 'profilo operatore'
                    ? 'person-fill'
                    : 'person'
                "
              ></b-icon>
              <span class="mb-0 ml-2 text-capitalize">{{ welcomeName }}</span>
            </router-link>
          </p>

          <p
            v-if="user.permessi.includes('navigare libreria')"
            class="pb_15 nav__item"
            :class="bancaDati.submenu ? 'bg-mdm-light-grey' : 'bg-white'"
          >
            <template v-if="bancaDati.submenu">
              <span
                class="d-flex align-items-center pl-1 py-1 general_border_3 point"
                :class="
                  $route.name === bancaDati.routeName
                    ? 'router-link-exact-active'
                    : ''
                "
                @click="bancaDati.submenuVisible = !bancaDati.submenuVisible"
                @keydown.enter.prevent="bancaDati.submenuVisible = !bancaDati.submenuVisible"
                @keydown.space.prevent="bancaDati.submenuVisible = !bancaDati.submenuVisible"
                role="button"
                tabindex="0"
                :aria-expanded="bancaDati.submenuVisible ? 'true' : 'false'"
                :aria-controls="bancaDati.name + '-sub'"
              >
                <b-icon font-scale="1.3" icon="book" aria-hidden="true"></b-icon>
                <span class="mb-0 ml-2 text-capitalize">{{
                  bancaDati.name
                }}</span>
                <b-icon
                  font-scale="1"
                  :icon="
                    bancaDati.submenuVisible ? 'chevron-up' : 'chevron-down'
                  "
                  class="mr-1 ml-auto"
                  aria-hidden="true"
                ></b-icon>
              </span>
              <b-collapse
                class="mt-1"
                :id="bancaDati.name + '-sub'"
                v-model="bancaDati.submenuVisible"
              >
                <p v-for="rt in localBancaDati" :key="rt.hashid" class="mb-1">
                  <span
                    class="d-flex align-items-center pl-1 py-1 general_border_3 align-items-cente point"
                    @click="handleClickBancaDati(rt)"
                    @keydown.enter.prevent="handleClickBancaDati(rt)"
                    @keydown.space.prevent="handleClickBancaDati(rt)"
                    role="button"
                    tabindex="0"
                  >
                    <b-iconstack aria-hidden="true" font-scale="1.3">
                      <b-icon
                        stacked
                        icon="circle"
                        variant="mdm-light-grey"
                        scale="0.55"
                      ></b-icon>
                      <b-icon
                        stacked
                        icon="circle"
                        variant="extra-light"
                      ></b-icon>
                    </b-iconstack>
                    <span class="mb-0 ml-2 text-capitalize">{{
                      rt.label
                    }}</span>
                  </span>
                </p>
                <p
                  class="mb-1"
                  v-if="
                    user.permessi.includes('visualizzare anagrafica azienda')
                  "
                >
                  <router-link
                    class="d-flex align-items-center pl-1 py-1 general_border_3 align-items-cente point"
                    exact-active-class="nav-active"
                    :to="{ name: 'bancadati' }"
                  >
                    <b-iconstack aria-hidden="true" font-scale="1.3">
                      <b-icon
                        stacked
                        icon="circle"
                        variant="mdm-light-grey"
                        scale="0.55"
                      ></b-icon>
                      <b-icon
                        stacked
                        icon="circle"
                        variant="extra-light"
                      ></b-icon>
                    </b-iconstack>
                    <span class="mb-0 ml-2 text-capitalize"> Configura </span>
                  </router-link>
                </p>
              </b-collapse>
            </template>
            <template v-else>
              <router-link
                class="d-flex align-items-center pl-1 py-1 general_border_3"
                :to="{
                  name: bancaDati.routeName,
                }"
              >
                <b-icon font-scale="1.3" icon="book"></b-icon>
                <span class="mb-0 ml-2 text-capitalize">{{
                  bancaDati.name
                }}</span>
              </router-link>
            </template>
          </p>
          <p
            class="pb_15 bg-mdm-light-grey nav__item"
            v-if="canSeeImpostazioni"
            :aria-controls="impostazioniSet.name + '-sub'"
          >
            <span
              class="d-flex align-items-center pl-1 py-1 general_border_3 point"
              :class="
                $route.name === 'impostazioniOperatore'
                  ? 'router-link-exact-active'
                  : ''
              "
              @click="
                impostazioniSet.submenuVisible = !impostazioniSet.submenuVisible
              "
              @keydown.enter.prevent="impostazioniSet.submenuVisible = !impostazioniSet.submenuVisible"
              @keydown.space.prevent="impostazioniSet.submenuVisible = !impostazioniSet.submenuVisible"
              role="button"
              tabindex="0"
              :aria-expanded="impostazioniSet.submenuVisible ? 'true' : 'false'"
              :aria-controls="impostazioniSet.name + '-sub'"
            >
              <b-icon font-scale="1.3" :icon="impostazioniSet.logo" aria-hidden="true"></b-icon>
              <span class="mb-0 ml-2">{{ impostazioniSet.name }}</span>
              <b-icon
                font-scale="1"
                :icon="
                  impostazioniSet.submenuVisible ? 'chevron-up' : 'chevron-down'
                "
                class="mr-1 ml-auto"
                aria-hidden="true"
              ></b-icon>
            </span>
            <template v-if="impostazioniSet.submenu">
              <b-collapse
                class="mt-1"
                :id="impostazioniSet.name + '-sub'"
                v-model="impostazioniSet.submenuVisible"
              >
                <p
                  v-for="rt in filteredImpostazioniSubroutes"
                  :key="'sub-' + rt.name"
                  class="mb-1"
                >
                  <router-link
                    class="d-flex align-items-center pl-1 py-1 general_border_3 align-items-center"
                    :to="{
                      name: impostazioniSet.routeName,
                      params: { section: rt.path },
                    }"
                    exact-active-class="nav-active"
                  >
                    <b-iconstack aria-hidden="true" font-scale="1.3">
                      <b-icon
                        stacked
                        icon="circle"
                        variant="mdm-light-grey"
                        scale="0.55"
                      ></b-icon>
                      <b-icon
                        stacked
                        icon="circle"
                        variant="extra-light"
                      ></b-icon>
                    </b-iconstack>
                    <span class="mb-0 ml-2 text-capitalize">{{ rt.name }}</span>
                  </router-link>
                </p>
              </b-collapse>
            </template>
          </p>
          <!-- SEGNALAZIONI (progetti con servizio segnalazioni attivo) -->
          <p v-if="hasSegnalazioniProject" class="pb_15 nav__item bg-white">
            <router-link
              class="d-flex align-items-center pl-1 py-1 general_border_3"
              :to="{ name: 'segnalazioni sperimentazione' }"
            >
              <b-icon font-scale="1.3" icon="megaphone"></b-icon>
              <span class="mb-0 ml-2">Segnalazioni</span>
            </router-link>
          </p>
          <!-- ARCHIVIO -->
          <p v-if="isFirstLevel && user.permessi.includes('navigare archivio')" class="pb_15 nav__item bg-white">
            <router-link
              class="d-flex align-items-center pl-1 py-1 general_border_3"
              :to="{ name: archivioSet.routeName }"
            >
              <b-icon font-scale="1.3" :icon="archivioSet.logo"></b-icon>
              <span class="mb-0 ml-2">{{ archivioSet.name }}</span>
            </router-link>
          </p>

          <p class="pb_15 nav__item bg-white">
            <router-link
              class="d-flex align-items-center pl-1 py-1 general_border_3"
              :to="{ name: 'guida' }"
            >
              <b-icon
                font-scale="1.3"
                :icon="
                  this.$route.name === 'guida'
                    ? 'info-circle-fill'
                    : 'info-circle'
                "
              ></b-icon>
              <span class="mb-0 ml-2">Guida</span>
            </router-link>
          </p>
          <p class="pb_15 nav__item bg-white general_border_3">
            <button
              type="button"
              class="nav__accessibility-trigger d-flex align-items-center pl-1 py-1"
              @click="handleAccessibilityShortcut"
              @keydown.enter.prevent="handleAccessibilityShortcut"
              @keydown.space.prevent="handleAccessibilityShortcut"
              aria-controls="accessibility-toolbar"
              :aria-label="$t('NavigationOperatore.accessibility')"
            >
              <b-icon font-scale="1.3" icon="sliders" aria-hidden="true"></b-icon>
              <span class="mb-0 ml-2">
                {{ $t('NavigationOperatore.accessibility') }}
              </span>
            </button>
          </p>
          <SendHelpRequest />
        </b-col>
        <!-- L'uscita è passata al menu dell'utente nell'header (2026-09-08):
             la modale `logout-confirm` resta qui perché è da qui che si apre. -->
      </b-row>
    </transition-group>
    <b-modal
      id="logout-confirm"
      centered
      :title="$t('NavigationOperatore.logout_confirm_title')"
      :ok-title="$t('NavigationOperatore.logout_confirm_ok')"
      ok-variant="popup-button"
      :cancel-title="$t('annulla')"
      cancel-variant="popup-button mr-2"
      footer-border-variant="white"
      @ok="onSubmit"
      @cancel="$bvModal.hide('logout-confirm')"
    >
      <!-- <h3>Confermi di voler uscire dall'area privata?</h3> -->
    </b-modal>
    <ModalChatPaziente modal-id="modal-chat-operatore" />
  </b-container>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import NotificationCenter from "@/app/layout/components/NotificationCenter.vue";
import SendHelpRequest from "@/app/common/components/utilities/SendHelpRequest.vue";
import { companyService, projectService } from "@/_services";
import { requestAccessibilityToolbarFocus } from "@/_utils/accessibility";
import ModalChatPaziente from "@/app/layout/components/ModalChatPaziente.vue";

export default {
  name: "NavigationOperatore",
  props: ["wlistener"],
  components: {
    NotificationCenter,
    SendHelpRequest,
    ModalChatPaziente,
  },
  watch: {
    $route() {
      if (this.$root.isCollapsed) {
        this.menuVisible = false;
      }
    },
    wlistener: function () {
      this.menuIsCompact = this.$refs.navmain.clientWidth <= 80;
    },
    company: {
      handler: function (newVal) {
        // if(!oldVal && newVal) {
        if (!newVal.bancaDati) {
          this.getCompanyBancaDati();
        }
        // }
        if (newVal) {
          this.isFirstLevel = newVal.level === 1;
        }
      },
      deep: true,
    },
    activeRefs: {
      handler(newVal) {
        if (Array.isArray(newVal) && newVal.includes(9) && this.hideProjectMenu) {
          this.getProjects();
        }
      },
      immediate: true,
    },
  },
  computed: {
    // La voce segue il meccanismo delle altre di primo livello: il feature
    // permission che la struttura concede dalle modali permessi. In piu' un
    // criterio di buon senso, chiesto esplicitamente: a chi non ha nessuna
    // conversazione la voce aprirebbe un elenco vuoto, quindi non compare -
    // a meno che non sia chi le conversazioni le amministra, che deve poterci
    // entrare anche prima di averne una.
    mostraMieConversazioni() {
      const permessi =
        this.user && Array.isArray(this.user.permessi) ? this.user.permessi : [];
      if (!permessi.includes("navigare le mie conversazioni")) {
        return false;
      }
      return this.haConversazioni || permessi.includes("gestire chat pazienti");
    },
    haConversazioni() {
      return this.$store.getters["chat/haCanali"];
    },
    chatNonLetti() {
      return this.$store.getters["chat/nonLetti"];
    },
    welcomeName() {
      if (
        this.user &&
        this.user.anagrafica &&
        this.user.anagrafica.name &&
        this.user.anagrafica.surname
      ) {
        return (
          this.user.anagrafica.name.toUpperCase() +
          " " +
          this.user.anagrafica.surname.toUpperCase().slice(0, 1) +
          "."
        );
      }
      return "Profilo";
    },
    canSeeImpostazioni() {
      if (this.user && this.user.type === 1) {
        return (
          this.user.permessi.includes("visualizzare anagrafica azienda") ||
          this.user.permessi.includes("gestire impostazioni dei servizi") ||
          this.user.permessi.includes("gestire operatori") ||
          this.user.permessi.includes("gestire fatturazione")
        );
      }
      return true;
    },
    visibleActiveServices() {
      if (
        this.user &&
        this.user.permessi &&
        !this.user.permessi.includes("gestire attività e questionari") &&
        !this.user.permessi.includes("somministrare questionari")
      ) {
        return this.activeServices.filter((service) => service.position_ref !== 3);
      }
      return this.activeServices;
    },
    filteredImpostazioniSubroutes() {
      let routes = this.impostazioniSet.subroutes;
      if (!this.userSubscriptionNeeds[1]) {
        routes = routes.filter(
          (route) => route.path !== "sottoscrizioni" && route.path !== "feature"
        );
      }
      if (this.user && this.user.permessi) {
        routes = routes.filter((route) => {
          if (route.nav_permission && !this.user.permessi.includes(route.nav_permission)) {
            return false;
          }
          if (route.position_ref) {
            return this.activeRefs.includes(route.position_ref) && this.companyHasService(route.position_ref);
          }
          return true;
        });
        if (!this.user.permessi.includes("gestire operatori")) {
          routes = routes.filter((route) => route.path !== "operatori");
        }
        if (!this.user.permessi.includes("visualizzare anagrafica azienda")) {
          routes = routes.filter(
            (route) => route.path !== "anagrafica" && route.path !== "sottoscrizioni"
          );
        }
      }
      routes = routes.filter(
        (route) =>
          !route.position_ref ||
          (this.activeRefs.includes(route.position_ref) &&
            this.companyHasService(route.position_ref))
      );
      return routes;
    },
    ...mapState("utente", ["status", "user"]),
    ...mapState({
      alert: (state) => state.alert,
    }),
    ...mapState("company", ["companyLoggedIn", "company"]),
    ...mapState("settings", ["activeRefs", "userSubscriptionNeeds"]),
    localBancaDati() {
      if (this.company && this.company.bancaDati) {
        return this.company.bancaDati;
      }
      return [];
    },
  },
  data() {
    return {
      menuVisible: true,
      showCompanyAlert: null,
      hasSegnalazioniProject: false,
      isFirstLevel: true,
      positions: {
        1: "prenotazioni",
        2: "teleconsulto",
        3: "attivita",
        4: "pazienti",
        5: "agenda",
        6: "clienti",
      },
      activeServices: [
        {
          name: "Pazienti",
          logo: "journal-medical",
          disabled: false,
          position_ref: 4,
          routeName: "pazienti",
          scope: undefined,
          submenu: false,
          nav_permission: "navigare pazienti",
        },
        {
          name: "Prenotazioni",
          logo: "calendar2",
          disabled: false,
          position_ref: 1,
          routeName: "prenotazioni",
          scope: undefined,
          submenu: true,
          nav_permission: "navigare prenotazioni",
          submenuVisible: false,
          subroutes: [
            {
              name: "Gestione",
              path: "prenotazioni",
            },
            {
              name: "Strumenti",
              path: "strumenti",
            },
            {
              name: "Report",
              path: "report",
            },
            {
              name: "Recall",
              path: "recall",
            },
          ],
        },
        {
          name: "Teleconsulto",
          logo: "chat-left",
          disabled: false,
          position_ref: 2,
          routeName: "teleconsulto",
          scope: undefined,
          submenu: true,
          nav_permission: "navigare teleconsulto",
          submenuVisible: false,
          subroutes: [
            {
              name: "Rapido",
              path: "rapido",
              position_ref: 10,
            },
            {
              name: "Pediatrico",
              path: "pediatrico",
              position_ref: 11,
            },
            {
              name: "Specialistico",
              path: "specialistico",
              position_ref: 2,
            },
            // {
            //   name: "Oggi",
            //   path: "videocall",
            // },
          ],
        },
        {
          name: "Screening",
          logo: "check2-square",
          disabled: false,
          position_ref: 3,
          routeName: "attivita",
          scope: undefined,
          submenu: true,
          nav_permission: "navigare screening",
          submenuVisible: false,
          subroutes: [
            {
              name: "Raccolte",
              path: "raccolte",
            },
            {
              name: "Questionari",
              path: "questionari",
            },
            {
              name: "Sessioni",
              path: "sessioni",
            },
          ],
        },
        {
          name: "Appuntamenti",
          logo: "kanban",
          disabled: false,
          position_ref: 5,
          routeName: "appuntamentiASL",
          submenu: true,
          nav_permission: "navigare appuntamenti",
          submenuVisible: false,
          subroutes: [
            {
              name: "Storico",
              path: "lista",
            },
            {
              name: "Nuovo",
              path: "nuovo",
            },
          ],
        },
        {
          name: "Piani Terapeutici",
          logo: "box-seam",
          disabled: false,
          position_ref: 7,
          routeName: "piani terapeutici",
          scope: undefined,
          submenu: false,
          nav_permission: "navigare piani terapeutici",
        },
        {
          name: "Monitoraggio",
          logo: "bullseye",
          disabled: false,
          position_ref: 8,
          routeName: "control room",
          scope: undefined,
          submenu: false,
          nav_permission: "navigare monitoraggio",
        },
        {
          name: "Chat Pazienti",
          logo: "chat-dots",
          disabled: false,
          position_ref: 19,
          routeName: "chat pazienti whitelist",
          scope: undefined,
          submenu: false,
          nav_permission: "navigare chat pazienti",
        },
        // {
        //   name: "Emergenze",
        //   logo: "exclamation-triangle",
        //   disabled: false,
        //   position_ref: 10,
        //   routeName: "emergenze",
        //   scope: undefined,
        //   submenu: false,
        // },
      ],
      bancaDati: {
        name: "Libreria",
        logo: "book",
        disabled: false,
        position_ref: 1,
        routeName: "bancadati",
        scope: undefined,
        submenu: true,
        submenuVisible: false,
      },
      agendaSet: {
        name: "Calendario",
        position_ref: 5,
        routeName: "agenda appuntamenti",
        logo: "calendar4",
        disabled: false,
        btnText: "Consulta",
      },
      progetti: {
        name: "Blog",
        logo: "journal",
        disabled: false,
        position_ref: 9,
        routeName: "progetti operatore",
        submenu: true,
        submenuVisible: false,
        subroutes: [],
      },
      analiticheSet: {
        name: "Statistiche",
        routeName: "analitiche",
        logo: "graph-up",
        disabled: false,
      },
      impostazioniSet: {
        name: "Impostazioni",
        routeName: "impostazioniOperatore",
        logo: "gear",
        disabled: false,
        submenu: true,
        submenuVisible: false,
        subroutes: [
          {
            name: "Servizi",
            path: "servizi",
          },
          {
            name: "Operatori",
            path: "operatori",
          },
          {
            name: "Anagrafica",
            path: "anagrafica",
          },
          {
            name: this.$t("NavigationOperatore.fatturazione"),
            path: "fatturazione",
            position_ref: 18,
            nav_permission: "gestire fatturazione",
          },
          {
            name: "Sottoscrizioni",
            path: "sottoscrizioni",
          },
          {
            name: "Personalizzazione",
            path: "personalizzazione",
            position_ref: 16,
            nav_permission: "visualizzare anagrafica azienda",
          },
        ],
      },
      archivioSet: {
        name: "Archivio",
        logo: "files",
        disabled: false,
        position_ref: 12,
        routeName: "archivio",
        submenu: false,
        submenuVisible: false,
        subroutes: [],
      },
      menuIsCompact: false,
      hideProjectMenu: true,
      isFever: false,
    };
  },
  methods: {
    apriModaleChat() {
      this.$bvModal.show("modal-chat-operatore");
    },
    ...mapActions("utente", ["logout"]),
    ...mapActions("company", ["logUserCompanyIn", "companyLogin"]),
    ...mapActions({
      clearAlert: "alert/clear",
      errorAlert: "alert/error",
      successAlert: "alert/success",
      infoAlert: "alert/info",
    }),
    ...mapMutations({
      updateCompanyBancaDati: "company/updateCompanyBancaDati",
    }),
    onSubmit() {
      this.logout();
    },
    handleAccessibilityShortcut() {
      requestAccessibilityToolbarFocus();
    },
    checkPath() {
      if (this.user) {
        return "/" + this.user.i_am + "/home";
      }
    },
    handleMenuSize() {
      var navById = document.getElementsByClassName("nav-desktop")[0];
      var currentWid = navById.clientWidth;
      if (currentWid <= 80) {
        //
        navById.style.minWidth = "inherit";
        navById.style.flex = "0 0 15em";
        this.menuIsCompact = false;
      } else {
        //
        navById.style.minWidth = "0";
        navById.style.flex = "0 0 79px";
        this.menuIsCompact = true;
      }
    },
    getCompanyBancaDati() {
      const self = this;
      companyService
        .getCompanyBancaDati()
        .then((response) => {
          self.updateCompanyBancaDati(response.data.data);
        })
        .catch(() => {
          self.errorAlert("Non è stato possibile scaricare la banca dati");
        });
    },
    getProjects() {
      const self = this;
      projectService
        .getOwnProjects()
        .then((response) => {
          const projects = response.data.data || [];
          self.hideProjectMenu = projects.length === 0;
          self.hasSegnalazioniProject = projects.some(
            (p) => p && p.segnalazioni_enabled
          );
          self.progetti.subroutes = projects.map((project) => {
            return {
              name: project.name,
              hashid: project.hashid,
            };
          });
        })
        .catch((error) => {
          if (error.status !== 403) {
            self.errorAlert("Non è stato possibile scaricare i progetti");
          }
        });
    },
    // Verifica isolata del servizio segnalazioni quando il menu progetti (ref 9)
    // non è attivo: imposta solo il flag, senza toccare il menu progetti.
    loadSegnalazioniFlag() {
      const self = this;
      projectService
        .getOwnProjects()
        .then((response) => {
          self.hasSegnalazioniProject = (response.data.data || []).some(
            (p) => p && p.segnalazioni_enabled
          );
        })
        .catch(() => {});
    },
    handleClickBancaDati(rt) {
      if (rt.open_iframe) {
        this.$emit("open-banca-dati", rt);
      } else {
        window.open(rt.url, "_blank");
      }
    },
    companyHasService(ref) {
      if (this.company) {
        return this.company.active_services.find(
          (el) => el.position_ref === ref
        )
          ? true
          : false;
      }
      return false;
    },
  },
  created() {
    // this.getCompanyBancaDati()

    if (this.$root.isCollapsed) {
      this.menuVisible = false;
    }
    this.$store.dispatch("chat/avvia");
    if (this.activeRefs.includes(9)) {
      this.getProjects();
    } else {
      this.loadSegnalazioniFlag();
    }
  },
  mounted() {
    this.menuIsCompact = this.$refs.navmain.clientWidth <= 80;
    this.isFever = this.company && this.company.projects_with_free_services
      ? this.company.projects_with_free_services.some(
          (el) => el.name === "FEVER"
        )
      : false;
  },
  beforeDestroy() {
    this.$store.dispatch("chat/ferma");
  },
};
</script>

<style lang="scss" scoped>
.nav__accessibility-trigger {
  background: transparent;
  border: 0;
  color: inherit;
  text-align: left;
  width: 100%;
}

.nav__accessibility-trigger:focus {
  outline: 2px solid #387db6;
  outline-offset: 2px;
}
</style>
